const remindPass = document.getElementById('forgot_pass_link');
const loginForm = document.getElementById('auth_login');
const remindForm = document.getElementById('auth_remind');
const backToLogin = document.getElementById('auth_back_to_login');

if (remindPass && loginForm && remindForm && backToLogin) {
    remindPass.addEventListener('click', () => {
        loginForm.classList.add('d-none');
        remindForm.classList.remove('d-none');
    });

    backToLogin.addEventListener('click', () => {
        loginForm.classList.remove('d-none');
        remindForm.classList.add('d-none');
    });
}
